//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Guids for Field Types. NOTE: Some of these are referenced in Migrations to avoid string-typos. */
export const FieldType = {
    /** Address field type */
    Address: "0A495222-23B7-41D3-82C8-D484CDB75D17",
    /** Assessment field type */
    AssessmentType: "C263513A-30BE-4823-ABF1-AC12A56F9644",
    /** Asset field type */
    Asset: "FC27D395-8F57-467E-91FF-E648F807110E",
    /** Asset Storage System field type */
    AssetStorageSystem: "A57109EE-35A2-45D0-A575-02DBBDFBC0D0",
    /** Attribute field type */
    Attribute: "99B090AA-4D7E-46D8-B393-BF945EA1BA8B",
    /** Audio File field type */
    AudioFile: "9772CB1F-3BC4-432E-80DD-D635CDB2DA32",
    /** Audio Url field type */
    AudioUrl: "3B2D8714-421C-4CB8-A892-58B83521EF8A",
    /** Background Check field type */
    Backgroundcheck: "D05B3808-803A-4531-9680-DD4AAB8ADF1A",
    /** Benevolence Request field type */
    BenevolenceRequest: "44EEC881-3C07-4A58-ACC4-0F21D873DBE0",
    /** Binary File field type */
    BinaryFile: "C403E219-A56B-439E-9D50-9302DFE760CF",
    /** Binary File Type field type */
    BinaryFileType: "09EC7F0D-3505-4090-B010-ABA68CB9B904",
    /** Binary File Types field type */
    BinaryFileTypes: "A5365133-FF87-48B3-BCA3-AF6D871F8895",
    /** Boolean field type */
    Boolean: "1EDAFDED-DFE6-4334-B019-6EECBA89E05A",
    /** Campus field type */
    Campus: "1B71FEF4-201F-4D53-8C60-2DF21F1985ED",
    /** Campuses field type */
    Campuses: "69254F91-C97F-4C2D-9ACB-1683B088097B",
    /** Captcha field type. */
    Captcha: "22F43337-7177-4064-9D4B-841EAD671678",
    /** Categories field type */
    Categories: "775899FB-AC17-4C2C-B809-CF3A1D2AA4E1",
    /** Category field type */
    Category: "309460EF-0CC5-41C6-9161-B3837BA3D374",
    /** Check List field type */
    CheckList: "31532E03-CF25-4A9F-855C-BA16C4075679",
    /** Code Editor field type */
    CodeEditor: "1D0D3794-C210-48A8-8C68-3FBEC08A6BA5",
    /** Color field type */
    Color: "D747E6AE-C383-4E22-8846-71518E3DD06F",
    /** Communication Preference field type */
    CommunicationPreferenceType: "507C28F2-8BC0-4909-A4FE-9C2B1149E2B2",
    /** Communication Template field type */
    CommunicationTemplate: "C3B37465-DCAF-4C8C-930C-9A9B5D066CA9",
    /** Comparison field type */
    Comparison: "3C742B81-3C55-48B8-A7CD-E7762EA5BB91",
    /** Component field type */
    Component: "A7486B0E-4CA2-4E00-A987-5544C7DABA76",
    /** Components field type */
    Components: "039E2E97-3682-4B29-8748-7132287A2059",
    /** Connection Activity Type field type */
    ConnectionActivityType: "39356C8F-B69E-4744-906C-0A182671B9F8",
    /** Connection Opportunity field type */
    ConnectionOpportunity: "B188B729-FE6D-498B-8871-65AB8FD1E11E",
    /** Connection Request field type */
    ConnectionRequest: "73A4B6C6-502B-4E5B-BAA0-A85B7CCEC544",
    /** Connection State field type */
    ConnectionState: "B0FB7AFB-B43C-4E2B-8502-293F07BB465A",
    /** Connection Status field type */
    ConnectionStatus: "EC381D5D-729F-4581-A8F7-8C1FCE44DA98",
    /** Connection Type field type */
    ConnectionType: "50DA6F25-E81E-46E8-A773-4B479B4FB9E6",
    /** Connection Types field type */
    ConnectionTypes: "E4E72958-4604-498F-956B-BA095976A60B",
    /** Content Channel field type */
    ContentChannel: "D835A0EC-C8DB-483A-A37C-E8FB6E956C3D",
    /** Content Channel Item field type */
    ContentChannelItem: "19BFB635-DC31-4C1E-8BB5-CDA120890BDE",
    /** Content Channel Type field type */
    ContentChannelType: "2B58514E-47F8-4740-A72C-B862B030855B",
    /** Content Channel Types field type */
    ContentChannelTypes: "DF974799-6656-4F0C-883D-85E44EEC999A",
    /** Currency field type */
    Currency: "3EE69CBC-35CE-4496-88CC-8327A447603F",
    /** A measure of necessity and/or availability of a data entry field. */
    DataEntryRequirementLevel: "0E989D0D-E07F-4460-B405-807588B36347",
    /** DataView field type */
    DataView: "BD72BBF1-0269-407E-BDBE-EEED4F1F207F",
    /** DataViews field type */
    Dataviews: "F739BF5D-3FDC-45EC-A03C-1AE7C47E3883",
    /** Date field type */
    Date: "6B6AA175-4758-453F-8D83-FCD8044B5F36",
    /** Date Range field type */
    DateRange: "9C7D431C-875C-4792-9E76-93F3A32BB850",
    /** Date Time field type */
    DateTime: "FE95430C-322D-4B67-9C77-DFD1D4408725",
    /** Day Of Week field type */
    DayOfWeek: "7EDFA2DE-FDD3-4AC1-B356-1F5BFC231DAE",
    /** Days Of Week field type */
    DaysOfWeek: "08943FF9-F2A8-4DB4-A72A-31938B200C8C",
    /** Decimal field type */
    Decimal: "C757A554-3009-4214-B05D-CEA2B2EA6B8F",
    /** Decimal Range field type */
    DecimalRange: "758D9648-573E-4800-B5AF-7CC29F4BE170",
    /** Defined Type field type */
    DefinedType: "BC48720C-3610-4BCF-AE66-D255A17F1CDF",
    /** Defined Value field type */
    DefinedValue: "59D5A94C-94A0-4630-B80A-BB25697D74C7",
    /** Categorized Defined Value field type */
    DefinedValueCategorized: "3D986B5C-A706-4C69-B0F2-7C81286194CF",
    /** Defined Value Range field type */
    DefinedValueRange: "B5C07B16-844D-4620-82E3-4CCA8F5FC350",
    /** Email field type */
    Email: "3D045CAE-EA72-4A04-B7BE-7FD1D6214217",
    /** Email Template field type */
    EmailTemplate: "CE7CA048-551C-4F68-8C0A-FCDCBEB5B956",
    /** Encrypted Text field type */
    EncryptedText: "36167F3E-8CB2-44F9-9022-102F171FBC9A",
    /** Entity field type */
    Entity: "B50968BD-7643-4288-9237-6E89D2065363",
    /** EntityType field type */
    Entitytype: "3549BAB6-FE1B-4333-AFC4-C5ACA01BB8EB",
    /** Event Calendar field type */
    EventCalendar: "EC0D9528-1A22-404E-A776-566404987363",
    /** Event Item field type */
    EventItem: "23713932-F558-45F7-BB00-2A550852F70D",
    /** File field type */
    File: "6F9E2DD0-E39E-4602-ADF9-EB710A75304A",
    /** Filter Date field type */
    FilterDate: "4F879A48-63DA-446F-837B-7458799298C0",
    /** Financial Account field type */
    FinancialAccount: "434D7B6F-F8DD-45B7-8C3E-C76EF10BE56A",
    /** Financial Accounts field type */
    FinancialAccounts: "17033CDD-EF97-4413-A483-7B85A787A87F",
    /** Financial Gateway field type */
    FinancialGateway: "7B34F9D8-6BBA-423E-B50E-525ABB3A1013",
    /** Gender field type */
    Gender: "2E28779B-4C76-4142-AE8D-49EA31DDB503",
    /** Group field type */
    Group: "F4399CEF-827B-48B2-A735-F7806FCFE8E8",
    /** Group And Role field type */
    GroupAndRole: "202F32AD-75C0-4259-850A-D08C0F3D3080",
    /** Group Location Type field type */
    GroupLocationType: "48624B0B-6A58-45B8-9E47-B67B67898D25",
    /** Group Member field type */
    GroupMember: "D092B5BB-A7F4-45B7-AB01-72CC4FC589A9",
    /** Group Role field type */
    GroupRole: "3BB25568-E793-4D12-AE80-AC3FDA6FD8A8",
    /** Group Type field type */
    GroupType: "18E29E23-B43B-4CF7-AE41-C85672C09F50",
    /** Group Type Group field type */
    GroupTypeGroup: "CC34CE2C-0B0E-4BB3-9549-454B2A7DF218",
    /** Group Types field type */
    GroupTypes: "F725B854-A15E-46AE-9D4C-0608D4154F1E",
    /** HTML field type */
    Html: "DD7ED4C0-A9E0-434F-ACFE-BD4F56B043DF",
    /** Image field type */
    Image: "97F8157D-A8C8-4AB3-96A2-9CB2A9049E6D",
    /** Integer field type */
    Integer: "A75DFC58-7A1B-4799-BF31-451B2BBE38FF",
    /** Integer Range field type */
    IntegerRange: "9D5F21E0-DEA0-4E8E-BA42-71151F6A8ED4",
    /** Interaction Channel field type */
    InteractionChannel: "5EE5D193-60B6-4808-9BE9-C5FFDDF444E4",
    /** Interaction Channels field type */
    InteractionChannels: "D5781EB0-3A2A-4FBB-AF8E-E14664147003",
    /** Key Value List field type */
    KeyValueList: "73B02051-0D38-4AD9-BF81-A2D477DE4F70",
    /** Label field type */
    Label: "8814CF68-435F-40F4-9A4C-ED6582835E0E",
    /** Lava field type */
    Lava: "27718256-C1EB-4B1F-9B4B-AC53249F78DF",
    /** Lava Commands field type */
    LavaCommands: "4BD9088F-5CC6-89B1-45FC-A2AAFFC7CC0D",
    /** Location field type */
    Location: "B0B9EFE3-F09F-4604-AD1B-76B298A85D83",
    /** Markdown field type */
    Markdown: "C2FBCF94-0FDF-4DFD-93A5-19FE6A409C84",
    /** Matrix field type */
    Matrix: "F16FC460-DC1E-4821-9012-5F21F974C677",
    /** Media Element field type */
    MediaElement: "A17D5AAC-B7AE-4587-B703-A0FC3625F0F8",
    /** Media Watch field type */
    MediaWatch: "98180C6F-5167-45E1-8ADE-E1A31EC4930D",
    /** Memo field type */
    Memo: "C28C7BF3-A552-4D77-9408-DEDCF760CED0",
    /** Merge Template field type */
    MergeTemplate: "890BAA33-5EBB-4343-A8AA-42E0E6C7467A",
    /** Metric field type */
    Metric: "AD52248B-B8C6-436E-9B57-E0BA4B42603E",
    /** Metric Categories field type */
    MetricCategories: "F5334A8E-B7E2-415C-A6EC-A6D8FA5341C4",
    /** Metric Entity field type */
    MetricEntity: "3A7FB32E-1CCD-4F79-B085-BDBADEB56CCF",
    /** Metrics field type */
    Metrics: "3AF9AD35-9F3E-4497-BFDE-60C6C1827653",
    /** Month Day field type */
    MonthDay: "8BED8DD8-8167-4052-B807-A1E72C133611",
    /** Multi-Select field type */
    MultiSelect: "BD0D9B57-2A41-4490-89FF-F01DAB7D4904",
    /** Note Type field type */
    NoteType: "E3FF88AC-13F6-4DF8-8371-FC0D7FD9A571",
    /** Note Types field type */
    NoteTypes: "276CCA63-5670-48CA-8B5A-2AAC97E8EE5E",
    /** Page Reference field type */
    PageReference: "BD53F9C9-EBA9-4D3F-82EA-DE5DD34A8108",
    /** Person field type */
    Person: "E4EAB7B2-0B76-429B-AFE4-AD86D7428C70",
    /** Person Badges field type */
    PersonBadges: "3F1AE891-7DC8-46D2-865D-11543B34FB60",
    /** Phone Number field type */
    PhoneNumber: "6B1908EC-12A2-463A-A7BD-970CE0FAF097",
    /** Range Slider field type */
    RangeSlider: "C8B6C51A-DD7C-4B75-8604-F0580697088E",
    /** Rating field type */
    Rating: "24BC2DD2-5745-4A97-A0F9-C1EC0E6E1862",
    /** Registration Instance field type */
    RegistrationInstance: "5F0F6D6A-DEB7-47AD-93C7-4CCC88EF932D",
    /** Registration Template field type */
    RegistrationTemplate: "E1EBAEE8-AF7E-426D-9A1B-02CBD785E620",
    /** Registration Template field type */
    ReminderType: "94A5DF3C-A7E0-451E-9DBA-86A6CFD5DF70",
    /** Registration Template field type */
    ReminderTypes: "C66E6BF9-4A73-4429-ACAD-D94D5E3A89B7",
    /** Remote Auths field type */
    RemoteAuths: "ECA90666-E7A0-4406-8559-0153DCB908FD",
    /** Report field type */
    Report: "B7FA826C-3367-4BF2-90E5-8C6730079D82",
    /** Schedule field type */
    Schedule: "E9C12C59-98EA-4977-8318-647435BE9A9C",
    /** Schedules field type */
    Schedules: "EC6A5CAF-F6A2-47A4-9CBA-6E1C53D7E59B",
    /** Security Role field type */
    SecurityRole: "7BD25DC9-F34A-478D-BEF9-0C787F5D39B8",
    /** Single-Select field type */
    SingleSelect: "7525C4CB-EE6B-41D4-9B64-A08048D5A5C0",
    /** Site field type */
    Site: "BB7AB90F-4DE9-4804-A852-F5593A35C8A0",
    /** Sliding Date Range field type */
    SlidingDateRange: "55810BC5-45EA-4044-B783-0CCE0A445C6F",
    /** Social Media Account field type */
    SocialMediaAccount: "92C0E3A1-9F63-49D4-B23B-73624AC42546",
    /** Social Security Number */
    Ssn: "4722C99A-C078-464A-968F-13AB5E8E318F",
    /** System Communication field type */
    SystemCommunication: "72ED40C7-4D64-4D60-9411-4FFB2B9E833E",
    /** System Email field type */
    SystemEmail: "08F3003B-F3E2-41EC-BDF1-A2B7AC2908CF",
    /** System Phone Number field type. */
    SystemPhoneNumber: "B8C35BA7-85E9-4512-B99C-12DE697DE14E",
    /** Text field type */
    Text: "9C204CD0-1233-41C5-818A-C5DA439445AA",
    /** Time field type */
    Time: "2F8F5EC4-57FA-4F6C-AB15-9D6616994580",
    /** Time Zone field type */
    TimeZone: "3FC8C1D3-3EBB-4887-A5A4-B9F300FC7B90",
    /** Url Link field type */
    UrlLink: "C0D0D7E2-C3B0-4004-ABEA-4BBFAD10D5D2",
    /** Value List field type */
    ValueList: "7BDAE237-6E49-47AC-9961-A45AFB69E240",
    /** Video File field type */
    VideoFile: "F1F5B59D-F086-4627-A94A-DFA7E67950F3",
    /** Video Url field type */
    VideoUrl: "E6FD57F3-1704-4E96-91A7-3D3E85346393",
    /** Workflow field type */
    Workflow: "0F72D8FD-983F-41FB-A7A3-E6403EB04EDB",
    /** Workflow Activity field type */
    WorkflowActivity: "739FD425-5B8C-4605-B775-7E4D9D4C11DB",
    /** Workflow Attribute field type */
    WorkflowAttribute: "33E6DF69-BDFA-407A-9744-C175B60643AE",
    /** Workflow Text Or Attribute field type */
    WorkflowTextOrAttribute: "3B1D93D7-9414-48F9-80E5-6A3FC8F94C20",
    /** Workflow Type field type */
    WorkflowType: "46A03F59-55D3-4ACE-ADD5-B4642225DD20",
    /** Workflow Types field type */
    WorkflowTypes: "1D50399B-0D6E-480B-A71A-E7BD37DD83F0",
};
